import script from "./KnowledgeBaseDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./KnowledgeBaseDetails.vue?vue&type=script&lang=ts&setup=true"

import "./KnowledgeBaseDetails.vue?vue&type=style&index=0&id=11d60957&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d60957"]])

export default __exports__